/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val1_TitleInputs */

const en_dr_room_val1_title = /** @type {(inputs: Dr_Room_Val1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests join free, no account`)
};

const id_dr_room_val1_title = /** @type {(inputs: Dr_Room_Val1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peserta gratis, tanpa akun`)
};

/**
* | output |
* | --- |
* | "Guests join free, no account" |
*
* @param {Dr_Room_Val1_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val1_title = /** @type {((inputs?: Dr_Room_Val1_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val1_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val1_title(inputs)
	return en_dr_room_val1_title(inputs)
});